import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Classes`}</p>
    <dl>
      <dt><a href="#TargetableSet">TargetableSet</a></dt>
      <dd>
        <p>{`A factory and manager for Targetable instances.
This class wraps around a TargetProvider, which identifies it as "your"
Targetable and enables automatic interception of targets.`}</p>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#TargetablePublisher">TargetablePublisher</a> : <inlineCode>function</inlineCode></dt>
      <dd>
        <p>{`Callback function which runs before committing this module's list of requested transforms to the build. Invoked as an intercept to `}<inlineCode parentName="p">{`builtins.transformModules`}</inlineCode>{`, this is the typical time to invoke your own target with your custom API.`}</p>
      </dd>
    </dl>
    <p>{`A factory and manager for Targetable instances.
This class wraps around a TargetProvider, which identifies it as "your"
Targetable and enables automatic interception of targets.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#TargetableSet"
        }}>{`TargetableSet`}</a>
        <ul parentName="li">
          <li parentName="ul"><em parentName="li">{`instance`}</em>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+module"
                }}>{`.module(modulePath, [publisher])`}</a>{` ⇒ `}<inlineCode parentName="li">{`TargetableModule`}</inlineCode></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+esModule"
                }}>{`.esModule(modulePath, [publisher])`}</a>{` ⇒ `}<inlineCode parentName="li">{`TargetableESModule`}</inlineCode></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+esModuleArray"
                }}>{`.esModuleArray(modulePath, [publisher])`}</a>{` ⇒ `}<inlineCode parentName="li">{`TargetableESModuleArray`}</inlineCode></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+esModuleObject"
                }}>{`.esModuleObject(modulePath, [publisher])`}</a>{` ⇒ `}<inlineCode parentName="li">{`TargetableESModuleObject`}</inlineCode></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+reactComponent"
                }}>{`.reactComponent(modulePath, [publisher])`}</a>{` ⇒ `}<inlineCode parentName="li">{`TargetableReactComponent`}</inlineCode></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+setSpecialFeatures"
                }}>{`.setSpecialFeatures(...Feature)`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet+defineEnvVars"
                }}>{`.defineEnvVars(sectionName, variables)`}</a></li>
            </ul>
          </li>
          <li parentName="ul"><em parentName="li">{`static`}</em>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#TargetableSet.using"
                }}>{`.using(targets)`}</a>{` ⇒ `}<a parentName="li" {...{
                  "href": "#TargetableSet"
                }}><inlineCode parentName="a">{`TargetableSet`}</inlineCode></a></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`TargetableModule`}</inlineCode>{`
— Returns an instance of TargetableModule.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modulePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to the module file this Targetable represents.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[publisher]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#TargetablePublisher"
            }}><inlineCode parentName="a">{`TargetablePublisher`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to execute when this module is about to commit its requested transforms to a build. If this function is passed, the module will automatically bind to `}<inlineCode parentName="td">{`builtins.transformModules`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`TargetableESModule`}</inlineCode>{`
— Returns an instance of TargetableESModule.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modulePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to the module file this Targetable represents.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[publisher]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#TargetablePublisher"
            }}><inlineCode parentName="a">{`TargetablePublisher`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to execute when this module is about to commit its requested transforms to a build. If this function is passed, the module will automatically bind to `}<inlineCode parentName="td">{`builtins.transformModules`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`TargetableESModuleArray`}</inlineCode>{`
— Returns an instance of TargetableESModuleArray.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modulePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to the module file this Targetable represents.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[publisher]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#TargetablePublisher"
            }}><inlineCode parentName="a">{`TargetablePublisher`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to execute when this module is about to commit its requested transforms to a build. If this function is passed, the module will automatically bind to `}<inlineCode parentName="td">{`builtins.transformModules`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`TargetableESModuleObject`}</inlineCode>{`
— Returns an instance of TargetableESModuleObject.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modulePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to the module file this Targetable represents.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[publisher]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#TargetablePublisher"
            }}><inlineCode parentName="a">{`TargetablePublisher`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to execute when this module is about to commit its requested transforms to a build. If this function is passed, the module will automatically bind to `}<inlineCode parentName="td">{`builtins.transformModules`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`TargetableReactComponent`}</inlineCode>{`
— Returns an instance of TargetableReactComponent`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modulePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to the module file this Targetable represents.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[publisher]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#TargetablePublisher"
            }}><inlineCode parentName="a">{`TargetablePublisher`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to execute when this module is about to commit its requested transforms to a build. If this function is passed, the module will automatically bind to `}<inlineCode parentName="td">{`builtins.transformModules`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Taps the builtin `}<inlineCode parentName="p">{`specialFeatures`}</inlineCode>{` target and sets the supplied feature flags.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`...Feature`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Array.<string>`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`object.<string, boolean>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`flags to set, as either string arguments, an array of string arguments, or an object of flags.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Tap the builtin `}<inlineCode parentName="p">{`envVarDefinitions`}</inlineCode>{` target to define new environment variables.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sectionName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Human-readable name of section. If a section with this name exists already, variables will be added to it instead o a new section being created.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`variables`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<EnvVarDefinition>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of variables to add.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Creates a new TargetableSet bound to a TargetProvider`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`targets`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`TargetProvider`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`TargetProvider for the curent dependency. This is the object passed by BuildBus to an intercept function.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Callback function which runs before committing this module's list of requested transforms to the build. Invoked as an intercept to `}<inlineCode parentName="p">{`builtins.transformModules`}</inlineCode>{`, this is the typical time to invoke your own target with your custom API.`}</p>
    <p><strong parentName="p">{`this`}</strong>{`: `}<inlineCode parentName="p">{`{TargetableModule}`}</inlineCode><br parentName="p"></br>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`self`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`TargetableModule`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The TargetableModule instance (for use if `}<inlineCode parentName="td">{`this`}</inlineCode>{` is not available)`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableSet.js"
      }}>{`pwa-studio/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableSet.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      